import { Link } from "react-router-dom";

/** 404 page, themed as a missing catalogue entry. */
export function NotFoundPage() {
  return (
    <div className="page">
      <div className="container center">
        <p className="eyebrow" style={{ justifyContent: "center" }}>
          Error · 404
        </p>
        <h1 className="page__title">Not in the catalogue</h1>
        <p className="page__intro" style={{ margin: "0 auto var(--space-4)" }}>
          That accession number doesn't match anything on file. It may have been
          moved, mis-filed, or never catalogued at all.
        </p>
        <Link to="/" className="btn">
          Return to the archive
        </Link>
      </div>
    </div>
  );
}
